export function runInBrowser() {
    return !!window;
}
export const isInWindowView = (ele, fixedTop = 0) => {
    if (!runInBrowser()) {
        return false;
    }
    const { top, bottom } = ele.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    if (bottom <= fixedTop) {
        return false;
    }
    if (top >= windowHeight - fixedTop) {
        return false;
    }
    return true;
};
